import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AtomizerJobsData, getInlineImage, updateCmDomains, deleteDataCM, fetchAttachmentURL, getFiles1 } from "../../API/api";
import { Skeleton } from "antd";
import Styles from "./Styles.module.css";
import {
  filterDomainsForComponent,
  replaceContentEditableText,
} from "../../utils";
import ReactQuill, { Quill } from "react-quill";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import VizHeader from "../VizHeader/VizHeader";
import VizButton from "../VizButtons/VizButton";
import MultiSelect from "../MultiSelect/MultiSelect";
import MultiSelectCm from "../MultiSelectCm/MultiSelectCm";
import MultiSelectCmTwo from "../MultiSelectCmTwo/MultiSelectCmTwo";
import { Card } from "antd";
import { toast } from "react-toastify";
import { GET_FILES } from "../../API/url";
import { Select } from 'antd'
import { Input } from 'antd'

const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};
const textStyles1 = {
  fontSize: "14px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginLeft: "5px"

};
const textStylesHeader = {
  fontSize: "18px",
  color: "#2A364A",
  fontWeight: "500",
  // lineHeight: "24px",

  // wordBreak: "break-word",
  marginRight: "5px"

};

const DataRenderer = ({ data, imageData, refreshFunc, video, videoFunc, domains, getHighlightedText, textFind }) => {
  const drawerState = useSelector((state) => state.drawer);
  const [text, setText] = useState(data.para);
  const [ques, setQues] = useState(data.head);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [relevantval, setReleventVal] = useState(data.relevant === null ? [] : data.relevant === undefined ? [] : data.relevant === 1 ? { name: "Relevant", value: 1, label: "Relevant" } : { name: "Non-Relevant", value: 0, label: "Non-Relevant" })
  const textRef = React.useRef(null);
  const successMsg = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const onClickButton = () => {
    let payload = { ...data };
    payload.head = ques;
    payload.para = text;
    payload.relevant = relevantval.length === 0 ? null : relevantval.value;
    let newPayload = {
      soId: null,
      domainIds: domains.map(dn => dn.indexId).toString(),
      data: [payload]
    }
    setIsLoading(true);
    // console.log("payload", newPayload)
    updateCmDomains(newPayload).then(res => {
      if (res === undefined) return;
      if (res.data.success) {
        toast.success(successMsg(res.data.message));
        data.para = text;
        data.head = ques;
        data.relevant = payload.relevant;
        setIsLoading(false);
        setIsEdit(false);
      }

    })
  };
  const deleteContents = (data) => {
    // console.log("hello", data);
    let payload = {
      type: 'para',
      data: [{ docId: data.docId }]
    }
    deleteDataCM(payload).then(res => {
      if (res === undefined) return;
      refreshFunc();
    })
  }
  const addImages = (str) => {
    let imagArr = Object.keys(imageData);
    for (let i = 0; i < imagArr.length; ++i) {
      if (imagArr[i].includes(".png")) {
        let replacedContent = `[content|${imagArr[i].split('.')[0]}|]`;
        let imgTag = `<img style='max-width:50%' src=${imageData[imagArr[i]]
          }></img>`;
        str = str.replaceAll(replacedContent, imgTag);
      } else {
        let imgTag = `<img style='max-width:50%' src=${imageData[imagArr[i]]
          }></img>`;

        let replacedContent = imagArr[i];
        str = str.replace(replacedContent, imgTag);
      }
    }
    return str;
  };


  const relevantOption=[
    { name: "Relevant", value: 1, label: "Relevant" },
    {
      name: "Non-Relevant",
      value: 0,
      label: "Non-Relevant",
    },
  ]
  const onChangeRelevant = (data) => {
    let val=relevantOption.filter((item)=>item.value===data)
    setReleventVal(val[0])
  }

console.log("relevantval sub",relevantval)
  return (
    <div className={Styles.cardcontainer}>
      {!isEdit && (
        <>
          <div
            style={{
              marginBottom: ".2rem",
              display: "flex",
              alignItems: "baseline",
            }}
          >
            <span className={Styles.cardHeading}>HEAD:</span>
            {textFind === '' ? <span id={'textRef'} style={{ width: "95%" }}>&nbsp;{data.head}</span>
              : getHighlightedText(data.head, textFind, { caseSensitive: false, highlightStyle: 'background-color: yellow; font-weight: bold;' })}
            {!drawerState.obj.indexed && (
              <span
                style={{
                  display: "flex",
                  justifyContent: "end",
                  color: "#999",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                <i className="fa fa-edit"
                  style={{ fontSize: '20px', color: '#ACB6C6', cursor: 'pointer' }}
                  onClick={() => setIsEdit(true)}></i>
                &nbsp;&nbsp;

                <i
                  className="fa fa-trash"
                  style={{ fontSize: '19px', color: '#ACB6C6', cursor: 'pointer' }}
                  onClick={() => deleteContents(data)}
                ></i>
              </span>
            )}
            <span
              style={{
                display: "flex",
                justifyContent: "end",
                color: "#999",
                fontSize: "16px",
                cursor: "pointer",
                marginLeft: '10px'
              }}
            >
              {!data.isPlay && video.length !== 0 && <i className="fa fa-play" onClick={() => videoFunc(data.docId, true)}></i>}
              {data.isPlay && video.length !== 0 && <i
                className="fa fa-pause"
                onClick={() => videoFunc(data.docId, false)}
              ></i>}
            </span>
          </div>
          <div className="mt-2 mb-2" style={{ textAlign: "center" }}>
            {data.bytes !== null && (
              <img style={{ maxWidth: "50%" }} src={data.bytes} />
            )}
            {data.isPlay && (
              <video width="50%" height="300" autoPlay controls>
                <source src={`${video}#t=${data.startTime},${data.endTime}`} type="video/mp4" />
              </video>
            )}
          </div>
          <div>
            <span className={Styles.cardHeading}>DATA:&nbsp;</span>
            {textFind === '' ? <span
              dangerouslySetInnerHTML={{
                __html: replaceContentEditableText(addImages(data.para)),
              }}
              style={{ fontSize: "14px" }}
            ></span> : getHighlightedText(data.para, textFind, { caseSensitive: false, highlightStyle: 'background-color: yellow; font-weight: bold;' })}
          </div>
        </>
      )}
      {isEdit && (
        <>
          <div
            style={{
              marginBottom: ".2rem",
              display: "flex",
              alignItems: "baseline",
              width: "100%",
            }}
          >
            {/* <input
              type="text"
              value={ques}
              style={{
                width: "100%",
                border: "1px solid lightgrey",
                borderRadius: "3px",
                height: "40px",
              }}
              onChange={(e) => setQues(e.target.value)}
            /> */}
            <textarea wrap="soft"

              style={{
                border: '1px solid lightgrey',
                width: '100%',
                fontSize: '12px',
                borderRadius: '3px',
                outline: 'none',
                resize: 'none',
                height: '30px',
                // height:"30px",
                // alignItems:"center",
                lineHeight: '30px',   // centers text vertically
                padding: '0 8px',
                overflow: "hidden"
              }}
              // style={{ border: '1px solid rgb(224, 226, 230)', width: '200px', padding: '12px', borderRadius: '6px', outline: 'none',resize: "none",height:"30px" }} 
              type={"text"}
              value={ques}
              onChange={(e) => setQues(e.target.value)}
            // minRows={1} 
            />
          </div>
          <div>
            <ReactQuill
              theme="snow"
              value={text}
              onChange={(e) => setText(e)}
            />
          </div>
          {!isLoading && <div className="mt-1" style={{ display: 'flex', justifyContent: "flex-end", alignItems: 'baseline' }}>
            {drawerState.obj.docType !== 'Video' && <div style={{ marginTop: '12px', width: "200px" }}>
              <span style={{ width: "100%" }}>
                {/* <MultiSelectCmTwo
                  value={relevantval}
                  onChangeFunc={onChangeRelevant}
                  isMulti={false}
                  options={[
                    { name: "Relevant", value: 1, label: "Relevant" },
                    {
                      name: "Non-Relevant",
                      value: 0,
                      label: "Non-Relevant",
                    },
                  ]}
                /> */}
                <Select
                  // mode="multiple"
                  style={{ width: "100%", height: "40px" }}
                  value={relevantval}
                  default={relevantval}
                  onChange={onChangeRelevant}
                  options={relevantOption}
                  maxTagPlaceholder={`${relevantval?.length || 0} selected`}
                  // allowClear={true}
                  maxTagCount="responsive"
                  placeholder="Select "
                />
              </span>
            </div>}
            &nbsp;
            <button

              onClick={() => setIsEdit(false)}
              style={{
                padding: '8px 12px 8px 12px',
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '24px',
                fontWeight: 400,
                boxShadow: ' 0px 1px 2px 0px #1018280D',
                color: '#2A364A',
                border: '1px solid  #fff',
                height: '40px',
                minWidth: '88px',
                background: " #F6F7F8",
                marginBottom: '14px',
                fontWeight: 400,
                border: " 1px solid #E0E2E6",
                // cursor: "not-allowed",
                marginRight: "5px"
                //  font-weight: 400;			
              }}
            // disabled={disabled}
            // disabled
            // className="buttonDark"
            >
              Cancel

            </button>
            <button

              onClick={onClickButton}
              style={{
                padding: '8px 12px 8px 12px',
                borderRadius: '6px',
                fontSize: '14px',
                lineHeight: '24px',
                fontWeight: 400,
                boxShadow: '0px 1px 2px 0px #1018280D',
                color: '#FFFFFF',
                border: '1px solid  #fff',
                height: '40px',
                minWidth: '88px',
                background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                marginBottom: '14px',
                cursor: "pointer",
                //  font-weight: 400;			
              }}
            // disabled={disabled}
            // disabled
            // className="buttonDark"
            >
              Save

            </button>
            {/* <VizButton size={2} type={"Tertiary"} onClick={() => setIsEdit(false)}>
              Cancel
            </VizButton>
            &nbsp;
            <VizButton size={2} type={"Primary"} onClick={onClickButton}>
              Save
            </VizButton> */}
          </div>}
        </>
      )}
    </div>
  );
};
export default function ReviewContent() {
  const drawerState = useSelector((state) => state.drawer);
  const userData = useSelector((state) => state.user);
  const fixDomainData = () => {
    if (
      drawerState.obj.domains === undefined ||
      drawerState.obj.domains === null
    ) {
      return [];
    }
    // let newDomains = [];
    let allDomains = filterDomainsForComponent(userData.expertTopics);
    let myDomains = drawerState.obj.domains.toString();
    let newDomains = allDomains.filter((obj) => {
      if (myDomains.includes(obj.name)) {
        return obj;
      }
    });
    return newDomains;
  };
  const [origData, setOrigData] = useState([]);
  const [data, setData] = useState([]);
  const [domains, setDomains] = useState(fixDomainData());
  const [link, setLink] = useState('');
  const [isRelevant, setRelevant] = useState({
    name: "All",
    value: "All",
    label: "All",
  });
  let [option, setOptions] = useState(
    filterDomainsForComponent(userData.expertTopics)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [inlineImageData, setInlineImageData] = useState("");
  const dispatch = useDispatch();
  const { isDrawerOpen } = bindActionCreators(Actions, dispatch);
  const [refreshData, setRefreshData] = useState('');
  const [textFind, setTextFind] = React.useState('');
  const [textReplace, setTextReplace] = React.useState('');
  const [ifTextFound, setTextIfFound] = React.useState(false)
  const [processedData, setProcessedData] = useState([]);
  const [totalMatches, setTotalMatches] = useState(0);
  // const regex = React.useMemo(() => new RegExp(textFind, 'gi'), [textFind]);
  //   const escapeRegExp = (string) => {
  //     return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };


  const escapedSearchString = React.useMemo(() => {
    return textFind ? escapeRegExp(textFind) : '';
  }, [textFind]);


  const regex = React.useMemo(() => {
    return escapedSearchString ? new RegExp(escapedSearchString, 'gi') : null;
  }, [escapedSearchString]);


  const refectorData = (data) => {
    let newData = data.filter(obj => {
      obj.isPlay = false;
      return obj;
    })
    return newData;
  }
  const reRefectorData = (id, flag) => {
    if (flag) {
      let newData = data.filter(obj => {
        obj.isPlay = false;
        if (obj.docId === id) {
          obj.isPlay = true;
        }
        return obj;
      })
      setData(newData);
    }
    if (!flag) {
      let newData = data.filter(obj => {
        obj.isPlay = false;
        return obj;
      })
      setData(newData);
    }
  }
  const fetchData = () => {
    setOrigData([]);
    setData([]);
    setIsLoading(true);
    if (drawerState.obj.docType === "Thread") {
      drawerState.payload.data[0].page = pageNo;
    }
    AtomizerJobsData(drawerState.payload).then((res) => {
      if (res === undefined) return;
      if (res.data.success) {
        if (res.data.data.inlineImages.length > 0) {
          getInlineImage(res.data.data.inlineImages).then((res2) => {
            if (res2 === undefined) return;
            if (res2.data.success) {
              setInlineImageData(res2.data.data);
            }
          });
        }
        if (res.data.data.video !== null) {
          let payload = [];
          payload.push(res?.data?.data?.video)
          console.log("res?.data?.data?.video}", res?.data?.data?.video);
          console.log("payload", payload)


          getFiles1(payload, setLink)
          // ?.then(res=>{
          //   console.log("reponse",res)
          //   if (res===undefined || res?.data?.data?.objectUrl===undefined) return;
          //   setLink(res?.data?.data?.objectUrl);
          // })
        }
        setData(
          drawerState?.obj?.docType === "Thread"
            ? res?.data?.data?.parsedData
            : refectorData(res?.data?.data?.parsedData[0])
        );
        setOrigData(
          drawerState.obj.docType === "Thread"
            ? res.data.data.parsedData
            : refectorData(res?.data?.data?.parsedData[0])
        );
        setIsLoading(false);
      }
    });
  };
  const onChangeDomain = (domain) => {
    console.log("domain", domain)
    setDomains(domain);

    let payload = {
      soId: drawerState.obj.soId,
      domainIds: domain.map(dn => dn).toString(),
      data: []
    }
    updateCmDomains(payload).then(res => {
    })
  };

  const relevantOptionData=[
    { label: "All", value: "All" },
    { label: "Relevant", value: "Relevant" },
    { label: "Non-Relevant", value: "Non-Relevant" },
  ]
  const onChangeRelevant = (option) => {
    let val=relevantOptionData.filter((item)=>item.value===option)
    setIsLoading(true);
    setRelevant(val[0]);
    if (option === 'All') {
      setData([]);
      setData(origData);
    }
    if (option === 'Relevant') {
      let newData = origData.filter(obj => {
        if (obj.relevant === 1) {
          return obj;
        }
      })
      setData([]);
      setData(newData);
    }
    if (option === 'Non-Relevant') {
      let newData = origData.filter(obj => {
        if (obj.relevant === 0) {
          return obj;
        }
      })
      setData([]);
      setData(newData);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  };
  const refresh = () => {
    setRelevant({
      name: "All",
      value: "All",
      label: "All",
    })
    setRefreshData(Math.random() * 10)
  }

  const highlightText = (text, searchTerm) => {
    if (!searchTerm) return { highlightedText: text, count: 0 };
    const escapedSearchTerm = escapeRegExp(searchTerm);
    const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
    const matches = text.match(regex);
    const highlightedText = text.replace(regex, '<span id="textRef" style="font-size:14px;font-weight: bold; background-color: yellow;">$1</span>');
    return { highlightedText, count: matches ? matches.length : 0 };
  };

  const formatInput = (event) => {
    const attribute = event.target.getAttribute('name');
    setTextFind((prevState) => ({
      ...prevState,
      [attribute]: event.target.value.trim()
    }));
  };

  const onChangeTextFind = (e) => {
    const trimmedValue = e.target.value.replace(/^\s+/, '');
    setTextFind(trimmedValue)
    // setTextFind(e.target.value.replace(/\s/g, ''));
    let totalCount = 0;
    const processed = data.map((item) => {
      let newItem = { ...item };
      const headResult = highlightText(item.head, trimmedValue);
      totalCount += headResult.count;
      const paraResult = highlightText(item.para, trimmedValue);
      totalCount += paraResult.count;
      newItem.head = headResult.highlightedText;
      newItem.para = paraResult.highlightedText;
      return newItem;
    });
    setProcessedData(processed);
    // setData(processed)
    setTotalMatches(totalCount);
  }

  const onChangeTextPlace = (e) => {
    setTextReplace('')
    const trimmedValue = e.target.value.replace(/^\s+/, '');
    setTextReplace(trimmedValue)
  }

  function onHandleInlineImages(str) {
    let imagArr = Object.keys(inlineImageData);
    for (let i = 0; i < imagArr.length; ++i) {
      if (imagArr[i].includes(".png")) {
        let replacedContent = `[content|${imagArr[i].split('.')[0]}|]`;
        let imgTag = `<img style='max-width:50%' src=${inlineImageData[imagArr[i]]
          }></img>`;
        str = str.replaceAll(replacedContent, imgTag);
      } else {
        let imgTag = `<img style='max-width:50%' src=${inlineImageData[imagArr[i]]
          }></img>`;

        let replacedContent = imagArr[i];
        str = str.replaceAll(replacedContent, imgTag);
      }
    }
    return str;
  }

  function getHighlightedText(text, highlight) {
    // Escape special characters for regex usage
    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    // Split the highlight input into words, escape each for regex, and join them into a regex pattern
    const highlightWords = highlight.split(/\s+/).filter(Boolean);
    const escapedHighlight = highlightWords.map(escapeRegExp).join('|');

    // Function to highlight text based on multiple highlight terms
    function highlightText(text) {
      if (!highlight) return text;

      // Create a regex to match any of the highlighted terms
      const regex = new RegExp(`(?<!\\S)(${escapedHighlight})(?!\\S)`, 'gi');

      // Highlight each matched term in the text
      return text.replace(regex, (match) => {
        return `<span style="font-size:14px; font-weight:bold; background-color:yellow;">${match}</span>`;
      });
    }

    function isValidHtmlTag(tag) {
      // Regex to validate standard HTML tags
      return /^<\/?[a-zA-Z][\w-]*(\s+[\w-]+(\s*=\s*("[^"]*"|'[^']*'|[^\s>]+))?)*\s*\/?>$/.test(tag);
    }

    // Function to handle the processing and highlighting of the input text
    function processText(text) {
      // Split the text into segments by matching HTML-like structures and preserving spaces
      const parts = text.split(/(<[^>]*>|\s+)/).filter(Boolean);

      // Map each segment to preserve HTML tags and apply highlighting where needed
      const processedParts = parts.map((part) => {
        // Check if the part is a valid HTML tag
        if (isValidHtmlTag(part)) {
          return part; // Return valid HTML tags without modification
        }
        // Handle partial or incomplete custom tags like <Me
        else if (part.startsWith('<') && !part.endsWith('>')) {
          const tagName = part.slice(1); // Remove only the starting <
          const highlightedTagName = highlightText(tagName); // Highlight the tag name content
          // Escape < to ensure it renders as text and not HTML
          return `&lt;${highlightedTagName}`;
        }
        // Handle complete custom tags like <Memory>
        else if (part.startsWith('<') && part.endsWith('>')) {
          const tagName = part.slice(1, -1); // Remove < and > for processing
          const highlightedTagName = highlightText(tagName); // Highlight the tag name content
          // Escape < and > to ensure it renders as text and not HTML
          return `&lt;${highlightedTagName}&gt;`;
        }
        // Apply highlighting to regular text parts
        return highlightText(part);
      });

      // Combine all parts back into a single string for rendering
      return processedParts.join('');
    }

    // Process and highlight the entire input text
    const highlightedText = processText(text);

    // Render the final highlighted text safely with dangerouslySetInnerHTML
    return (
      <span
        style={{ width: '95%', fontSize: '14px' }}
        dangerouslySetInnerHTML={{ __html: replaceContentEditableText(onHandleInlineImages(highlightedText)) }}
      />
    );
  }
  /* Working function except tag like <Memory> is not getting highlighted */



console.log("isRelevant2",isRelevant)


  const onButtonReplace = () => {
    // setData(processedData)
    const successMsg = (message) => {
      return (
        <>
          <span style={{ fontSize: "12px" }}>{message}</span>
        </>
      );
    };
    // let payloadArr = []
    let payloadArr = data.filter((item, index) => {
      if (regex.test(item.head) || regex.test(item.para)) {
        let newItem = item.head.replace(regex, (match) => `${textReplace}` + ` `)
        item.head = newItem
        let newItem2 = item.para.replace(regex, (match) => `${textReplace}` + ` `)
        item.para = newItem2;
        // payloadArr.push(item)
        return item;
      }
    })
    // setData(newArr)
    // let payload = { ...data };
    // console.log(payload, 'check payload')
    // payload.head = ques;
    // payload.para = text;
    // payload.relevant = relevantval.length === 0 ? null : relevantval.value;
    let newPayload = {
      soId: null,
      domainIds: domains.map(dn => dn.indexId).toString(),
      data: payloadArr
    }
    if (payloadArr.length > 0) {
      setIsLoading(true);
      updateCmDomains(newPayload).then(res => {
        if (res === undefined) return;
        if (res.data.success) {
          toast.success(successMsg(res.data.message));
          // data.para = text;
          // data.head = ques;
          // data.relevant = payload.relevant;
          setIsLoading(false);
          // setIsEdit(false);
          setTextFind('')
          setTextReplace('')
        }
      })
    }
  }

  useEffect(() => {
    fixDomainData();
    fetchData();
    setTextFind('')
    setTextReplace('')
  }, [refreshData]);
  console.log("domains", isRelevant)
  return (
    <>
      {isLoading && (
        <div>
          <Skeleton active />
          <br />
          <Skeleton active />
          <br />
          <Skeleton active />
          <br />
          <Skeleton active />
        </div>
      )}
      {!isLoading && (
        <div style={{ overflowY: 'auto' }} >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className={Styles.header} style={{ width: "55%" }}>
              <span style={textStylesHeader}>Review Content</span>
              {/* <VizHeader type={"2"}>Review Content1</VizHeader> */}
            </div>
            <div style={{
              width: "45%", textAlign: "end",
            }}>
              <i
                className="fa fa-times-circle"
                onClick={() => isDrawerOpen(false)}
                style={{
                  // width: "45%",
                  fontSize: "24px",
                  color: "#dc2f02",
                  cursor: "pointer",

                }}
              ></i>
            </div>
          </div>
          <hr style={{ marginBottom: "0px" }} />
          <div
            className="mt-4 mb-2"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div style={{ width: "200px" }}>
              {drawerState.obj.docType !== "Thread" &&
                drawerState.obj.docType !== "urlcrawl" &&
                !drawerState.obj.indexed && (
                  // <MultiSelect
                  //   isMulti={true}
                  //   value={domains}
                  //   onChangeFunc={onChangeDomain}
                  // />
                  //   <Select
                  //   labelInValue
                  //   options={ingestTypeObj}
                  //   value={doctype}
                  //   // defaultValue={{ label: 'All', value: null }}
                  //   onChange={onChangeDocType}
                  //   placeholder="Select "
                  //   //  popupClassName={Styles.searchSuggestionCss}
                  //   size="middle"
                  //   showSearch
                  //   filterOption={(input, option) =>
                  //     (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  //   }
                  //   style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
                  // />
                  // <Select
                  //   mode="multiple"
                  //   style={{ width: "100%" }}
                  //   placeholder="Select Domains"
                  //   // value={domains}
                  //   value={domains.map(d => d.indexId)}
                  //   onChange={onChangeDomain}
                  //   // onChange={(ids) => {
                  //   //   setDomains(ids);
                  //   //   console.log("ids",ids)
                  //   //   updateCmDomains({ soId: drawerState.obj.soId, domainIds: ids.toString(), data: [] });
                  //   // }}
                  //   maxTagPlaceholder={`${domains?.length || 0} selected`}
                  //   allowClear={true}
                  //   maxTagCount="responsive"
                  //   options={option.map(item => ({ label: item.name, value: item.indexId }))} />
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder="Select Domains"
                    value={domains.map(d => d.indexId)}   // extract ids for Select
                    onChange={(ids) => {
                      const selectedObjs = option.filter(o => ids.includes(o.indexId));
                      setDomains(selectedObjs);

                      let payload = {
                        soId: drawerState.obj.soId,
                        domainIds: ids.toString(),
                        data: []
                      };
                      updateCmDomains(payload);
                    }}
                    maxTagPlaceholder={`${domains?.length || 0} selected`}
                    allowClear
                    maxTagCount="responsive"
                    options={option.map(item => ({ label: item.name, value: item.indexId }))}
                  />

                )}
            </div>
            <div>
              {(drawerState.obj.docType !== "Thread" && drawerState.obj.docType !== "Video") && (
                <>
                  {/* <MultiSelectCmTwo
                  value={isRelevant}
                  onChangeFunc={onChangeRelevant}
                  isMulti={false}
                  options={[
                    { name: "All", value: "All", label: "All" },
                    { name: "Relevant", value: "Relevant", label: "Relevant" },
                    {
                      name: "Non-Relevant",
                      value: "Non-Relevant",
                      label: "Non-Relevant",
                    },
                  ]}
                /> */}
                  <div style={{ width: "200px" }}>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select Option"
                      value={isRelevant}
                      onChange={onChangeRelevant}
                      defaultValue={{ label: "All", value: "All", name: "All" }}
                      options={[
                        { label: "All", value: "All" },
                        { label: "Relevant", value: "Relevant" },
                        { label: "Non-Relevant", value: "Non-Relevant" },
                      ]}
                      maxTagPlaceholder={`${isRelevant?.length || 0} selected`}
                      // allowClear={true}
                      maxTagCount="responsive" // or set to 0 to fully replace
                    // maxTagPlaceholder={(omittedValues) => `${isRelevant.length} selected`}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <span style={{ display: "flex", alignItems: "center" }}>
            {drawerState.obj.indexed === false && data.length > 0 &&
              <>
                {/* <input autoComplete="off" className="mb-2" type="text" placeholder="Replace From"
                  value={textFind} name="name" onChange={(e) => onChangeTextFind(e)}
                  //  style={{ width: '200px', fontSize: '12px', borderRadius: '3px', border: '1px solid lightgrey', padding: '4px 8px' }} 
                  style={{
                    border: '1px solid lightgrey',
                    width: '200px',
                    fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    height: '30px',
                    // height:"30px",
                    // alignItems:"center",
                    // lineHeight: '30px',   // centers text vertically
                    padding: '0 8px',
                  }}
                /> */}
                <textarea
                  wrap="soft"
                  style={{
                    border: '1px solid rgb(224, 226, 230)',
                    width: '200px',            // same width as input
                    height: '30px',            // same height as input
                    // fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    padding: '0 8px',          // horizontal padding only
                    lineHeight: '30px',        // ✅ centers text vertically
                    boxSizing: 'border-box',
                    overflow: 'hidden'   // ensures exact dimensions
                  }}
                  rows={1}
                  placeholder="Replace From"
                  autoComplete="off"
                  value={textFind}
                  name="name"
                  onChange={(e) => onChangeTextFind(e)}
                />


                {/* <textarea
                  wrap="soft"
                  
                  style={{
                   border: '1px solid rgb(224, 226, 230)', width: '10%', padding: '12px', borderRadius: '6px', outline: 'none',height:"30px", }}
                  rows={"auto"} 
                  type={"text"}
                  placeholder="Replace From"
                  autoComplete="off"
                  value={textFind}
                  name="name" onChange={(e) => onChangeTextFind(e)}
                  // minRows={2}
                /> */}
              </>
            }
            {(textFind !== '' && drawerState.obj.indexed === false) && <><span style={textStyles1}>{" "}Total Matches:{" "}{totalMatches}</span></>}
          </span>
          {drawerState.obj.indexed === false && data.length > 0 &&
            <>
              <div style={{ marginTop: "8px" }}>
                {/* <></> */}
                {/* <input autoComplete="off" className="mb-1" placeholder="Replace To"
                  //  style={{ width: '200px', fontSize: '12px', borderRadius: '3px', border: '1px solid lightgrey', padding: '4px 8px' }} 
                  style={{
                    border: '1px solid lightgrey',
                    width: '200px',
                    fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    height: '30px',
                    // height:"30px",
                    // alignItems:"center",
                    // lineHeight: '30px',   // centers text vertically
                    padding: '0 8px',
                  }}

                  value={textReplace} onChange={(e) => onChangeTextPlace(e)} /> */}
                <textarea
                  wrap="soft"
                  style={{
                    border: '1px solid rgb(224, 226, 230)',
                    width: '200px',            // same width as input
                    height: '30px',            // same height as input
                    // fontSize: '12px',
                    borderRadius: '3px',
                    outline: 'none',
                    resize: 'none',
                    padding: '0 8px',          // horizontal padding only
                    lineHeight: '30px',        // ✅ centers text vertically
                    boxSizing: 'border-box',
                    overflow: 'hidden'   // ensures exact dimensions
                  }}
                  rows={1}
                  placeholder="Replace To"
                  autoComplete="off"
                  value={textReplace}
                  name="name"
                  onChange={(e) => onChangeTextPlace(e)}
                />
              </div>
              {((textFind !== '' && textReplace !== '' && totalMatches > 0) && drawerState.obj.indexed === false) &&
                <>
                  <button

                    onClick={() => onButtonReplace()}
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: '0px 1px 2px 0px #1018280D',
                      color: '#FFFFFF',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                      cursor: "pointer",
                      //  font-weight: 400;			
                    }}
                  // disabled={disabled}
                  // disabled={disabled || editorState?.publishButtonBool}
                  // className="buttonDark"
                  >
                    Replace

                  </button>
                  {/* <div className="mt-1 mb-2">
                    <VizButton size={4}
                      type={"Primary"} onClick={onButtonReplace}>onButtonReplace</VizButton>
                  </div> */}
                </>


              }
              {
                ((textFind === '' || textReplace === '' || textFind && textReplace === '' || totalMatches === 0) && drawerState.obj.indexed === false) &&
                <div className="mt-1 mb-2">
                  <button

                    onClick={() => onButtonReplace()}
                    style={{
                      padding: '8px 12px 8px 12px',
                      borderRadius: '6px',
                      fontSize: '14px',
                      lineHeight: '24px',
                      fontWeight: 400,
                      boxShadow: '0px 1px 2px 0px #1018280D',
                      color: '#FFFFFF',
                      border: '1px solid  #fff',
                      height: '40px',
                      minWidth: '88px',
                      background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                      marginBottom: '14px',
                      cursor: "not-allowed",
                      //  font-weight: 400;			
                    }}
                    // disabled={disabled}
                    disabled
                  // className="buttonDark"
                  >
                    Replace

                  </button>
                  {/* <VizButton size={4} type={'Disabled'}>Replace</VizButton> */}
                </div>
              }
            </>}
          {
            data?.length > 0 && <Card style={{ boxShadow: "7px 7px 20px lightgrey" }}>
              {data.map((obj) => {
                return (
                  <>
                    {drawerState.obj.docType !== "Thread" && (
                      <DataRenderer domains={domains} imageData={inlineImageData} data={obj} videoFunc={reRefectorData} video={link} refreshFunc={refresh} textFind={textFind} getHighlightedText={getHighlightedText} />
                    )}
                    {/* {drawerState.obj.docType === "Thread" &&
                    obj.map((obj2) => {
                      return (
                        <DataRenderer imageData={inlineImageData} data={obj2} />
                      );
                    })} */}
                  </>
                );
              })}
            </Card>
          }

        </div>
      )}
    </>
  );
}
